import { Injectable, Type } from '@angular/core';

@Injectable()
export class InjectedComponentsBaseService {

    GetComponents(destination: string): Type<any>[] {
        return [];
    }
}